module.exports = __webpack_public_path__ + "plus-button-orange.svg?05947f3f50aa92f7b53edba2741a8a94";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plus-button-orange.svg
// module id = 645
// module chunks = 0